export enum OrderActionTypes {
  GET_ALL_ORDERS = '@order/GET_ALL_ORDERS',
  GET_REWARDS_PROCESSED = '@order/GET_REWARDS_PROCESSED',
  ACTIVATE_BOOSTER = '@order/ACTIVATE_BOOSTER',
}
